import axios from 'axios'
import {AzSearchUrlBuilder} from '@azinformatica/loki'
import UrlUtils from '@/core/utils/UrlUtils'

class OrgaoApiClient {

    async buscar(filtro) {

        return axios.get(AzSearchUrlBuilder
            .build('api/unidades-organizacionais',filtro, {}))
    }

    async buscarTodos(filtro) {
        return axios.get(AzSearchUrlBuilder.build('api/unidades-organizacionais/todas', filtro, {}))
    }

}

export default new OrgaoApiClient()
